export default "__VITE_ASSET__1r72kUlu__"